import { CurrencyPipe } from '@angular/common';

export class SecurityType {
  securityTypeId: string;
  identifier: string;
  class: string;
  nominalPrice: number;
  paidAmount: number;
  unpaidAmount: number;
  name: string;
  entityId: string;
  isPosted: boolean;

  // ui only
  trackId = Math.random();

  constructor(data: Partial<SecurityType> = {}) {
    this.securityTypeId = data.securityTypeId ?? '';
    this.identifier = data.identifier ?? '';
    this.class = data.class ?? 'ORD';
    this.nominalPrice = data.nominalPrice ?? 1;
    this.paidAmount = data.paidAmount ?? 1;
    this.unpaidAmount = data.unpaidAmount ?? 0;
    this.name = data.name ?? 'Ordinary';
    this.entityId = data.entityId ?? '';
    this.isPosted = data.isPosted ?? false;
  }

  isEqual(securityType: SecurityType): boolean {
    if (this.securityTypeId && this.securityTypeId === securityType.securityTypeId) {
      return true;
    }

    return (
      this.class === securityType.class
      && this.nominalPrice === securityType.nominalPrice
      && this.paidAmount === securityType.paidAmount
      && this.unpaidAmount === securityType.unpaidAmount
    );
  }

  static buildIdentifier(securityType: SecurityType): string {
    const nominalPriceLabel = SecurityType.getMoneyLabel(securityType.nominalPrice);
    const unpaidAmountLabel = SecurityType.getMoneyLabel(securityType.unpaidAmount);

    return `${ securityType.class }@${ nominalPriceLabel }/${ unpaidAmountLabel }`;
  }

  static getMoneyLabel(price: number | null | undefined, outerCurrencyPipe: CurrencyPipe | null = null): string | null {
    if (price === null || price === undefined) {
      return '';
    }

    const absPrice = Math.abs(price);
    const currencyPipe = outerCurrencyPipe ?? new CurrencyPipe('en-AU');

    if (absPrice >= 0.01) {
      // If share absPrice is > 0.01$ show it with mask 0.xx (as it is right now)
      return currencyPipe.transform(price, '$', 'code', '1.2-2') ?? '';
    } else if (absPrice >= 0.0001) {
      // if share absPrice < 0.01$ but > 0.0001$ show it with mask 0.xxxx (like 0.0001$)
      return currencyPipe.transform(price, '$', 'code', '1.2-4') ?? '';
    }

    // if share absPrice < 0.0001$ show it as 0.00$
    return currencyPipe.transform(0, '$', 'code', '1.2-2') ?? '';
  }
}
